// Mirrors native/src/editor/activity/plugins/challenge/StoryWalkFlow.js evaluate().
// Phase-machine activity: success = terminal state in runTrace OR phaseFlags.completed.

'use strict';

const {reachedTerminalState, totalBlockCount} = require('./helpers');

function evaluate (activityData, simState) {
    const phaseFlags = (simState && simState.phaseFlags) || {};
    return {
        success: reachedTerminalState(simState),
        usedBlocks: totalBlockCount(simState),
        storyPhase: phaseFlags.storyPhase || null
    };
}

module.exports = evaluate;
